







































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as AssetAPI from "@/services/api/assets";
import { AssetVersion } from "@/psychlab/types/assets";
import { FullscreenModal } from "@/components.generic/fullscreen-modal";
import { ViewAssetHistory } from "@/components.assets/view-asset-history";

export default defineComponent({

	emits:[
		"closed"
	],
	props:{
	},
	components:{
		FullscreenModal,
		ViewAssetHistory,
	},
	setup(props, context){
		
		const modal = ref<any>();
		const asset = ref<string>();
		
		const version = ref<string>();

		const versions = ref<AssetVersion<any>[]>([]);

		const open = async (config:{ asset:string, version?:string }) => {
			
			if(!modal.value){ return; }


			version.value = config.version;

			if(!config.version){
				const versions = await AssetAPI.loadVersionList(config.asset);
				version.value = versions[0]._id;
			}

			// if(!versions.length){
			// 	return;
			// }
			
			
			asset.value = config.asset;
			modal.value.open();


			
		};

		const hide = () => {
			if(!modal.value){ return; }
			modal.value.close();
			asset.value = undefined;
			version.value = undefined;
			context.emit("closed");
		};
		

		return {
			asset,
			version,
			modal,
			hide,
			open,
		};
	}
});

